const jwtCookie = {
  "name": "jwt",
  "maxAge": 31536000000
}

export default jwtCookie